import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBubbleWide"><Path d="M4.75 3C3.23122 3 2 4.23122 2 5.75V16.25C2 17.7688 3.23122 19 4.75 19H8.65182C8.71055 19 8.76741 19.0207 8.81242 19.0584L10.8775 20.7894C11.5249 21.3321 12.4676 21.3348 13.1181 20.7959L15.2164 19.0575C15.2613 19.0203 15.3177 19 15.3759 19H19.25C20.7688 19 22 17.7688 22 16.25V5.75C22 4.23122 20.7688 3 19.25 3H4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWide;
